import { compose } from 'redux';
import { withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withPageControl } from '@dpdgroupuk/fmx-ui/components/Page';
import type { AuthorizedParcel, Route } from '@dpdgroupuk/fmx-ui/types';
import { withModal } from '@dpdgroupuk/fmx-ui/components/Dialog';
import { IMAGES } from '@dpdgroupuk/fmx-ui/themes';

import { ROBOT_ARRIVED, trackable } from '../../../../../constants/analytics';
import { fetchRouteAndDriver } from '../actions';

import { getParcelProgressData } from '../model';
import {
  backToDpdSiteHeader,
  changeDeliveryHeader,
  changeDeliverySpeedDeal,
  getDpdAppHeader,
  goToParcelInfoHeader,
  learnAboutYourRobotHeader,
  learnAboutYourDriverSpeedDeal,
  trackAnotherParcelHeader,
  whatHappensNextHeader,
  whatHappensNextSpeedDeal,
} from '../../../../controlActions';
import withFetch from '../../../../../HOCs/withFetch';
import { getDriverArriveTimeText } from '../../../../../models/parcel';
import { MORE_COOL_STUFF } from '../../../../../constants/message';
import { withParcelInfo } from '../../../hocs';
import RobotArrivedDesktopView from './RobotArrivedDesktopView';

type Props = {
  parcel: AuthorizedParcel,
  route: Route,
  driver: any,
};

const createHeaderControlActions = props => {
  const generalHeaderControlActions = [
    goToParcelInfoHeader(props),
    whatHappensNextHeader(props),
    changeDeliveryHeader(props),
    learnAboutYourRobotHeader(props),
    trackAnotherParcelHeader(props),
    backToDpdSiteHeader(props),
    getDpdAppHeader(props),
  ];

  if (props.parcel.airDiagActive) {
    return [...generalHeaderControlActions];
  }

  return generalHeaderControlActions;
};

const createSpeedDealControlActions = props => [
  learnAboutYourDriverSpeedDeal(props),
  changeDeliverySpeedDeal(props),
  whatHappensNextSpeedDeal(props),
];

export default compose(
  withRouter,
  withModal,
  withFetch(fetchRouteAndDriver, {
    dataPropMapper: ([route, driver]) => ({
      route,
      driver,
    }),
  }),
  withProps(({ parcel, route, driver }: Props) => ({
    additionalInfo: getDriverArriveTimeText(parcel),
    ...getParcelProgressData(parcel, route, driver),
  })),
  withPageControl({
    title: MORE_COOL_STUFF,
    backgroundImage: IMAGES.TRACKING_BG,
    trackable: trackable(ROBOT_ARRIVED),
    isFooterHidden: true,
    headerMenuActions: createHeaderControlActions,
    speedDealActions: createSpeedDealControlActions,
    // isMobileMenuShevronVisible: true,
  }),
  withParcelInfo()
)(RobotArrivedDesktopView);
